import DashboardLayout from '../../../../layouts/DashboardLayout';
import { DataTable } from '../../../../components/DataTable/DataTable';
import {
  FaSyncAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaNetworkWired,
  FaHeartbeat,
  FaSlidersH,
} from 'react-icons/fa';
import stylesMetrics from '../../styles/stylesMetrics.module.css';
import styles from "../../styles/styles.module.css"
import { useState, useEffect } from 'react';
import { interoperabilityApi } from '../../api/interoperability.api';
import toast from 'react-hot-toast';
import { TABS_OPTIONS } from '../../interfaces/interoperability.interfaces';
import { useServices } from '../../hooks/useServices';
import { tabs } from '../../interfaces/interoperability.interfaces';
import ModalConfigurationConector from '../../components/ModalConfigurationConector/ModalConfigurationConector';
import ApiDetailModal from '../../components/ApiDetailModal/ApiDetailModal';
import { MODE } from '../../../../interaces/mode.interface';
import ActionsTable from '../../../../components/GenericComponents/ActionsTable';
import ConfirmationMessage from '../../../../components/GenericComponents/ConfirmationMessage';
import { TOAST_INFO_IDS, TOAST_SUCCESS_IDS } from '../../../../interaces/toast.ids.interface';
import MetricCard from '../../components/MetricCard/MetricCard';
import { useMetrics } from '../../hooks/useMetrics';
import { useHistory } from '../../hooks/useHistory';
import StatusSelect from '../../components/StatusSelect/StatusSelect';
import { ENUM_PERMISSIONS } from '../../../../interaces/enums/enums.interface';
import { useAuth } from '../../../../context/AuthContext';
function Interoperability() {
  const [model, setModel] = useState(null);
  const [mode, setMode] = useState(MODE.CREATE);
  const [openModal, setOpenModal] = useState(false);
    const { hasPrivilege } = useAuth();

  const {
    entities,
    setEntities,
    fetchSearch,
    loading,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
  } = useServices();
  const {
    entities: entitiesHistory,
    setEntities: setEntitiesHistory,
    searchValue: searchValueHistory,
    setSearchValue: setSearchValueHistory,
    fetchSearch: fetchHistory,
    loading: loadingHistory,
    onClear: onClearHistory,
    dataPagination: dataPaginationHistory,
    setPageData: setPageDataHistory,
    pageData: pageDataHistory,
  } = useHistory();
  const {
    entities: metrics,
    setEntities: setmetrics,
    searchValue: searchValueMetrics,
    setSearchValue: setSearchValueMetrics,
    fetchMetrics,
    loading: loadingMetrics,
    onClear: onClearMetrics,
  } = useMetrics();
  const [activeTab, setActiveTab] = useState(
    hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_READ)
      ? TABS_OPTIONS.SERVICES
      : hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_METRICS_READ)
        ? TABS_OPTIONS.METRICS
        : TABS_OPTIONS.RECORD
  );

  useEffect(() => {
    if (activeTab == TABS_OPTIONS.SERVICES) {
      fetchSearch();
    }
    if (activeTab == TABS_OPTIONS.METRICS) {
      fetchMetrics();
    }
    if (activeTab == TABS_OPTIONS.RECORD) {
      fetchHistory();
    }
  }, [activeTab]);
  useEffect(() => {
    fetchMetrics();
  }, []);
  //DataTable
  const [scanning, setScanning] = useState(false);
  const [selectedApi, setSelectedApi] = useState(null);
  const [serviceToEdit, setServiceToEdit] = useState(null);
  const [syncingCode, setSyncingCode] = useState(null);
  const [openModalDetails, setOpenModalDetails] = useState(false);
  const handleDelete = async () => {
    try {
      await interoperabilityApi.deleteService(model.code);
      setShowConfirmationMessage(false);
      setEntities((prev) => prev.filter((service) => service.code !== model.code));
      toast.success(TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY, {
        id: TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY,
      });
    } catch (err) {
      toast.error('Error al eliminar: ' + err.message);
    }
  };
  const handleSyncSingle = async (code) => {
    setSyncingCode(code);
    try {
      const response = await interoperabilityApi.syncService(code);
      setEntities((prev) => prev.map((item) => (item.code === response.code ? response : item)));
      toast.success(`Sincronización de '${code}' completada`);
    } catch (err) {
      toast.error('Error al sincronizar: ' + err.message);
    } finally {
      setSyncingCode(null);
    }
  };

  const handleHealthCheck = async (code) => {
    setSyncingCode(code + ':health');
    try {
      const response = await interoperabilityApi.healthCheck(code);
      setEntities((prev) => prev.map((item) => (item.code === response.code ? response : item)));
      const ok = response.healthStatus === 'OK';
      if (ok) toast.success(`Health check OK — ${code}`);
      else toast.error(`Health check FALLIDO — ${response.healthMessage || code}`);
    } catch (err) {
      toast.error('Error en health check: ' + err.message);
    } finally {
      setSyncingCode(null);
    }
  };

  const handleStatusChange = async (code, newStatus) => {
    try {
      const response = await interoperabilityApi.updateStatus(code, newStatus);
      setEntities((prev) => prev.map((item) => (item.code === response.code ? response : item)));
    } catch (err) {
      toast.error('Error al cambiar estado: ' + err.message);
    }
  };

  const handleScanAll = async () => {
    setScanning(true);
    try {
      const updatedList = await interoperabilityApi.scanAll();
      if (Array.isArray(updatedList)) setEntities(updatedList);
      toast.success('Escáner masivo completado');
    } catch (err) {
      toast.error('Error en escáner masivo: ' + err.message);
    } finally {
      setScanning(false);
    }
  };

  const handleEdit = (item) => {
    setModel(item);
    setMode(MODE.UPDATE);
    setOpenModal(true);
  };

  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false);
  const confirmDelete = (model) => {
    setModel(model);
    setShowConfirmationMessage(true);
  };
  const columns = [
    {
      accessorKey: 'name',
      header: 'SERVICIO',
      cell: ({ row }) => {
        const item = row.original;

        return (
          <div className={styles.divName}>
            <p>{item.name}</p>

            <div className={styles.divM2 }>
              <label className={styles.nameProtocolType}>{item.protocolType}</label>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: 'institution',
      header: 'INSTITUCIÓN',
    },
    {
      accessorKey: 'version',
      header: 'VERSION',
    },
    {
      accessorKey: 'status',
      header: 'ESTADO',
      cell: ({ row }) => {
        const item = row.original;
        return (
          <StatusSelect
            value={item.status}
            onChange={(newStatus) => handleStatusChange(item.code || item.name, newStatus)}
          />
        );
      },
    },
    {
      accessorKey: 'healthStatus',
      header: 'HEALTH',
      cell: ({ row }) => {
        const healthStatus = row.original.healthStatus;

        return healthStatus === 'OK' ? (
          <span className={styles.spanIconFaCheckCircleOk}>
            <FaCheckCircle />
            OK
          </span>
        ) : healthStatus === 'ERROR' ? (
          <span className={styles.spanIconFaTimesCircleError}>
            <FaTimesCircle />
            Error
          </span>
        ) : (
          <span className={styles.spanNoIcon}>—</span>
        );
      },
    },
    {
      accessorKey: 'lastSync',
      header: 'ÚLTIMA SYNC',
      cell: ({ row }) => {
        const item = row.original;
        return <p>{item.lastSync || '-'}</p>;
      },
    },
    {
      id: 'acciones',
      header: 'ACCIONES',
      cell: ({ row }) => {
        const item = row.original;
        return (
                <div className="div-actions">
            <button
              className="btn-action-ActionsTable "
              onClick={() => {
                setSelectedApi(item);
                setOpenModalDetails(true);
              }}
              title="Probar conexión e introspeccionar campos para XSD"
            >
              <FaSlidersH className={styles.iconBtnFaSlidersH} />
            </button>

            <button
              className="btn-action-ActionsTable "
              title="Health check real"
              onClick={() => handleHealthCheck(item.code || item.name)}
              disabled={syncingCode === (item.code || item.name) + ':health'}
            >
              <FaHeartbeat className={styles.iconBtnFaHeartbeat } />
            </button>

            <button
              className="btn-action-ActionsTable "
              title="Sincronizar ahora con Camel"
              onClick={() => handleSyncSingle(item.code || item.name)}
              disabled={syncingCode === (item.code || item.name) + ':health'}
            >
              <FaSyncAlt
                className={`${styles.iconBtnFaSyncAlt}  ${
                  syncingCode === (item.code || item.name) ? 'animate-spin' : ''
                }`}
              />
            </button>

            <ActionsTable
              handleEdit={() => handleEdit(item)}
              handleDelete={() => confirmDelete(item)}
              tienePermisoEditar={hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_UPDATE)}
              tienePermisoEliminar={hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_DELETE)}
            />
          </div>
        );
      },
    },
  ];
  const columnsHistory = [
    {
      accessorKey: 'id',
      header: 'ID',
    },
    {
      accessorKey: 'targetSystem',
      header: 'SISTEMA',
    },
    {
      accessorKey: 'action',
      header: 'ACCIÓN',
    },
    {
      accessorKey: 'status',
      header: 'RESULTADOS',
      cell: ({ row }) => {
        const item = row.original;
        return (
          <>
            {item.success ? (
              <span className={styles.spanIconFaCheckCircleOk}>
                <FaCheckCircle />
                OK
              </span>
            ) : (
              <span className={styles.spanIconFaTimesCircleError}>
                <FaTimesCircle />
                Error
              </span>
            )}
          </>
        );
      },
    },
    {
      accessorKey: 'latencyMs',
      header: 'LATENCIA',
    },
    {
      accessorKey: 'timestamp',
      header: 'TIMESTAMP',
    },
  ];
  //
  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">
              Consulta de servicios interoperables conectados al sistema.
            </p>
          </div>
        </div>
        <div className="tabs-bar">
          {tabs.map(
            (tab) =>
              hasPrivilege(tab.permission) && (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`tab-item ${activeTab === tab.id ? 'tab-item-active' : ''}`}
                >
                  {tab.icon} {tab.id}
                </button>
              )
          )}
        </div>

        {activeTab == TABS_OPTIONS.SERVICES && (
          <>
            {hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_CREATE) && (
              <div className={styles.divScanAll}>
                <button
                  className={styles.btnScanAll}
                  onClick={handleScanAll}
                  disabled={scanning}
                  title="Probar conectividad de todos los servicios mediante Apache Camel"
                >
                  <FaNetworkWired className={scanning ? 'animate-spin' : ''} />
                  {scanning ? 'Escaneando...' : 'Escanear Todo'}
                </button>
              </div>
            )}
            <DataTable
              columns={columns}
              data={entities}
              searchPlaceholder="Buscar servicio..."
              pageSize={4}
              loading={loading}
              emptyMessage="No hay registros"
              onRowClick={(data) => {}}
              showSearch={true}
              showPagination={true}
              onSearch={() => fetchSearch()}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              showCreate={hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_CREATE)}
              titleButtonCreate={'Configurar Conector'}
              setOpenModal={setOpenModal}
              setMode={setMode}
              setModel={setModel}
              onClear={() => onClear()}
              dataPagination={dataPagination}
              setPageData={setPageData}
              pageData={pageData}
            />
          </>
        )}
        {activeTab === TABS_OPTIONS.METRICS && (
          <div>
            <div className={stylesMetrics.metricsRow}>
              <MetricCard
                label="Total Servicios"
                value={metrics.totalServices || 0}
                color="var(--color-primary)"
              />
              <MetricCard
                label="Conectados"
                value={metrics?.onlineServices ?? 0}
                color="var(--color-success)"
                sub="Estado: OK"
              />
              <MetricCard
                label="En Mantenimiento"
                value={metrics?.maintenanceServices ?? 0}
                color="var(--color-warning)"
                sub="Estado: warning"
              />
              <MetricCard
                label="Desconectados"
                value={metrics?.offlineServices ?? 0}
                color="var(--color-danger)"
                sub="Estado: error"
              />
            </div>
            <div className={stylesMetrics.metricsRow}>
              <MetricCard
                label="Total Consultas"
                value={metrics?.totalQueries ?? 0}
                color="#7C3AED"
                sub="Desde el arranque"
              />
              <MetricCard
                label="Exitosas"
                value={metrics?.successfulQueries ?? 0}
                color="var(--color-success)"
                sub={
                  metrics?.totalQueries
                    ? `${Math.round((metrics.successfulQueries / metrics.totalQueries) * 100)}% éxito`
                    : '—'
                }
              />
              <MetricCard
                label="Latencia Promedio"
                value={metrics?.avgLatencyMs ? `${metrics.avgLatencyMs} ms` : '—'}
                color="#0EA5E9"
                sub="Apache Camel"
              />
            </div>
            <div className={stylesMetrics.metricsRefershContainer}>
              <button
                className="btn-primary"
                onClick={() => {
                  fetchMetrics();
                }}
              >
                <FaSyncAlt /> Refrescar Métricas
              </button>
            </div>
          </div>
        )}

        {activeTab === TABS_OPTIONS.RECORD && (
          <DataTable
            columns={columnsHistory}
            data={entitiesHistory}
            searchPlaceholder="Buscar Log..."
            pageSize={4}
            loading={loadingHistory}
            emptyMessage="No hay registros"
            onRowClick={(data) => {}}
            showSearch={true}
            showPagination={true}
            onSearch={() => fetchHistory()}
            searchValue={searchValueHistory}
            setSearchValue={setSearchValueHistory}
            onClear={() => onClearHistory()}
            dataPagination={dataPaginationHistory}
            setPageData={setPageDataHistory}
            pageData={pageDataHistory}
          />
        )}

        {openModal && (
          <ModalConfigurationConector
            model={model}
            mode={mode}
            serviceToEdit={serviceToEdit}
            onClose={() => {
              setOpenModal(false);
              setServiceToEdit(null);
            }}
            setEntities={setEntities}
          />
        )}
        {showConfirmationMessage && (
          <ConfirmationMessage
            message={
              model
                ? `${TOAST_INFO_IDS.ARE_YOU_SURE_WANT_TO_DELETE_THIS} el servicio "${model.name}"?`
                : TOAST_INFO_IDS.ARE_YOU_SURE_WANT_TO_DELETE_THIS_RECORD
            }
            onConfirm={handleDelete}
            onCancel={() => {
              setShowConfirmationMessage(false);
              setModel(null);
            }}
          />
        )}
        {openModalDetails && (
          <ApiDetailModal api={selectedApi} onClose={() => setSelectedApi(null)} />
        )}
      </div>
    </DashboardLayout>
  );
}

export default Interoperability;
